export default __webpack_public_path__ + "static/defaultOverlay-wide-bcc1fb7aa688a3e47c7d3fdcc1850f86.png";